export default "__VITE_ASSET__D6COwZ$m__"